import axios, { API_ENDPOINTS } from '../axios';
import { getHeadersWithToken } from './functions';

export async function getTaskStatus(id: string) {
  const res = await axios.get(`${API_ENDPOINTS.tasks.getStatus}/${id}`, {
    headers: getHeadersWithToken(),
  });
  return res;
}
